import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementRotaCategoryData, IRotaManagementRotaCategoryResponse } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useCategoryListAPI = () => {
  const [categoryList, setCategoryList] = useState<IRotaManagementRotaCategoryData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async () => {
    // dispatch(
    //   setLoading({
    //     key: "isOrgServicesInProgress",
    //     status: true,
    //   })
    // );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(ROTA_APIS?.ROTA_SHIFT_CATEGORY?.baseURL ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IRotaManagementRotaCategoryResponse>) => {
          if (res.data.status === true) {
            setCategoryList(res.data.data);
            // dispatch(setCategory({ data:  }));
          } else {
            //
            setCategoryList([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return { execute, categoryList };
};
